import {
  Box,
  KdsCardFile,
  KdsEmptyContent,
  KdsText,
  VStack,
} from "@kazaar-platform/design-system";
import { useTranslate } from "@tolgee/react";
import { useFile } from "@/hooks/queries/useFile";
import { type DeliveryNoteBlocProps } from "./DeliveryNoteBloc.types";

export const DeliveryNoteBloc = ({ orderItem }: DeliveryNoteBlocProps) => {
  const { t } = useTranslate();

  const { useDownloadFileHandler } = useFile();
  const { handleDownloadFile } = useDownloadFileHandler();

  const deliveryNotes = orderItem?.deliveryNotes;

  return (
    <Box w="100%" rounded="br-md" bgColor="elevation.first" p="sp-md">
      <VStack gap="sp-md">
        <KdsText size="title-sm">
          {t("order.myOrdersItemDetails.deliveryNote")}
        </KdsText>

        <Box maxH="450px" overflowY="auto">
          <VStack gap="sp-md">
            {deliveryNotes?.length ? (
              deliveryNotes.map((deliveryNote) => (
                <KdsCardFile
                  key={deliveryNote?.url}
                  fileName={deliveryNote?.fileName}
                  fileSize={deliveryNote?.size}
                  fileUrl={deliveryNote?.url}
                  isViewable
                  isDownloadable
                  onDownload={() =>
                    handleDownloadFile(
                      deliveryNote?.fileName,
                      deliveryNote?.url
                    )
                  }
                />
              ))
            ) : (
              <KdsEmptyContent
                title={t("documentEmptyState.title")}
                description={t("documentEmptyState.subtitle")}
              />
            )}
          </VStack>
        </Box>
      </VStack>
    </Box>
  );
};
